import '../img/DataFiscal.jpg';
import '../img/GDA.jpg';
import '../img/Liniers-Horizontal.jpg';
import '../img/Liniers-Vertical.jpg';
import '../img/LN.svg';
import '../img/LN-Mas.svg';
import '../img/Lupa.svg';
import '../img/Tarjeta_ClubLN.png';
import '../img/imagen-placeholder-cine.png';
import '../img/imagen-placeholder-teatro.png';
import '../img/marker-icon.png';
import '../img/marker-icon-2x.png';
import '../img/marker-shadow.png';


// WEBPACK FOOTER //
// ./Statics/scripts/ImagesImports.js